import React from 'react';
import T from 'prop-types';
import { times } from 'lodash-es';
import cx from 'classnames';

const Skeleton = ({ width = '100%', height = 12, borderRadius = 4, style, className }) => (
  <div
    data-testid="skeleton"
    className={cx('skeleton', className)}
    style={{ width, height, borderRadius, ...style }}
  />
);

export const skeletonTable = ({ columns = [], rowsNumber = 3, height }) =>
  times(rowsNumber).map(() =>
    columns.reduce(
      (acc, item) => ({
        ...acc,
        [item]: <Skeleton height={height} borderRadius={6} />,
      }),
      {}
    )
  );

Skeleton.propTypes = {
  width: T.oneOfType([T.string, T.number]),
  height: T.oneOfType([T.string, T.number]),
  borderRadius: T.oneOfType([T.string, T.number]),
  className: T.string,
  style: T.object,
};

export default Skeleton;
